<template>
    <a :id="id"
       tabindex="0"
       :class="params.classes"
       role="button"
       data-toggle="popover"
       :data-placement="params.position"
       data-trigger="focus"
       :title="params.title"
       :data-content="params.data_content">
        <i class="material-icons">{{params.icon}}</i>
        {{params.button_text}}</a>
</template>

<script>
    import {uniqueId} from '../helpers/classesAndIds';


    export default {
        // name: "pop_over",
        mounted() {
            let _this = this, element = [];

            _this.id = uniqueId('vue-popover');
            // console.log('_this.content', _this.content);
            if (typeof _this.content !== 'undefined') {
                for (let key in _this.params) {
                    _this.params[key] = _this.content.hasOwnProperty(key) ? _this.content[key] : _this.params[key];
                }
            }

            _this.$nextTick(function () {

                setTimeout(function () {
                    element = document.getElementById(_this.id);
                    if (typeof(element) != 'undefined' && element != null) {
                        // console.log(' _this.id', _this.id)
                        $('#' + _this.id).popover(_this.options);
                    } else {
                        console.log(`popover ${_this.id} not rendered`);
                    }
                }, 200);
            });


        },
        props: ['content'],
        data: () => {
            /*
            'class' => null,
                'title' => '',
                'button_text' => '',
                'content' => '',
                'icon' => 'help_outline',
                'position' => 'top',
                'button' => 'btn btn-lg',
                */
            return {
                options:{
                    html:true
                },
                params: {
                    'title': 'Info',
                    'position': 'top',
                    'data_content': 'some content',
                    'icon': 'help_outline',
                    'button_text': '',
                    'classes': ''
                },
                popoverRender: true,
                popover: {},
                id: '',
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/PopOver.vue?415f87ed